import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise} from "angular";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('AktiverSmsOtpDialog');
require('./aktiverSmsOtpDialog.scss');

export class AktiverSmsOtpDialog {

    static visAktiverSmsOtpDialog($mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon());
    }

    private static dialogKonfigurasjon(): angular.material.IDialogOptions {
        return {
            template: require('./aktiverSmsOtpDialog.html'),
            controller: AktiverSmsOtpDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            AktiverSmsOtpDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    lukk(){
        this.$mdDialog.hide();
    }

    avbryt() {
        this.$mdDialog.cancel();
    }
}
